import React from 'react'

const Photo = () => {
  return (
    <div>
        
      <div className='h-screen bg-slate-800 '>
        <div className='bg-photo h-screen bg-cover bg-no-repeat'>

        </div>

      </div>
    </div>
  )
}

export default Photo
